<template>
  <div class="orders">
    <Breadcrumbs v-bind:breadcrumbs="breadcrumbs" />
    <OrdersTable @create-order="onCreateOrder" @edit-order="onEditOrder" />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs';
import OrdersTable from '@/components/Orders/OrdersTable';

export default {
  name: 'Orders',
  components: {
    Breadcrumbs,
    OrdersTable,
  },
  computed: {
    breadcrumbs() {
      return [{ name: 'Home', route: { name: 'home' } }, { name: this.$t('orders') }];
    },
  },
  methods: {
    onCreateOrder() {
      this.$router.push({ name: 'OrderCreatePage' });
    },
    onEditOrder(order) {
      this.$router.push({
        name: 'OrderEditPage',
        params: { orderNumber: order.number },
      });
    },
  },
};
</script>

<style lang="scss"></style>
